module.exports = __webpack_public_path__ + "0fb0e93c92da75f9a05a3beb06b91c6f.png";